import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { push } from 'connected-react-router';
import { ApplicantList } from 'components';
import { useLocalErrorHandler } from 'hooks';

const QecQualificationContainer = ({
    setErrorHandler, getApplicantList, apiError, applicantList, onPush,
}: Props) => {
    useLocalErrorHandler(setErrorHandler);

    const [processing, setProcessing] = React.useState(false);

    useEffect(() => {
        const fetch = async () => {
            setProcessing(true);
            await getApplicantList({});
            setProcessing(false);
        };

        fetch();
    }, []);


    const handleApplicantSelect = (id: string) => {
        onPush(`/applicant-details/${id}/info`);
    };

    return (
        <ApplicantList
          getList={getApplicantList}
          handleApplicantSelect={handleApplicantSelect}
          applicantList={applicantList}
          apiError={apiError}
          processing={processing}
          filters={{}}
        />
    );
};

const mapState = (state: IRootState) => ({
    applicantList: state.applicants.applicantList,
    apiError: state.errors.error,
});

const mapDispatch = (dispatch: Dispatch) => ({
    onPush: (key: string) => dispatch(push(key)),
    getApplicantList: dispatch.applicants.getApplicantListAsync,
    setErrorHandler: dispatch.errors.setErrorHandler,
});

export default connect(mapState, mapDispatch)(QecQualificationContainer);

type Props = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;
